import React, { useCallback } from 'react';
import { useModalStore } from '@/store';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import useRequireAuth from '@/hooks/useRequireAuth';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

const CollectionsRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const { openModal } = useModalStore(state => state.actions);
  const requireAuth = useRequireAuth();

  const handleOpenCreateModal = useCallback(() => {
    requireAuth(
      () => openModal('CreateCollectionModal'),
      {
        source: 'collections_header_new',
        title: 'Sign in to create a Collection',
        subtitle: 'Collections group files and chats so Gab can pull from the same context across every conversation.',
        icon: 'folder-plus',
      },
    );
  }, [openModal, requireAuth]);

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="plus"
        tooltip={t('nav.routes.collections.newCollectionTooltip')}
        label={isXS ? undefined : t('nav.routes.collections.newCollection')}
        onPress={handleOpenCreateModal}
      />
    </NavigationBarButtonContainer>
  );
});

CollectionsRouteNavigationHeaderRight.displayName = 'CollectionsRouteNavigationHeaderRight';

const CollectionsRouteNavigationOptions = {
  title: 'Collections',
  headerTitle: 'Collections',
  headerRight: () => <CollectionsRouteNavigationHeaderRight />
};

export default CollectionsRouteNavigationOptions; 